import { ReviewWizard } from 'trellis-ecosystem';
import { useEcosystemReviews } from '../../hooks/useEcosystemReviews';
import { jsx as _jsx } from "react/jsx-runtime";
export function EcosystemReviewWizard({
  children,
  customValidationErrors,
  defaultReview,
  HeaderComponent,
  isEditing,
  editReason,
  offeringId,
  onChange,
  onClose,
  onFail,
  onSuccess,
  originalReview,
  overrideSubmitValidation,
  reviewFormatter,
  reviewId,
  reviewType,
  showLegalCheckbox,
  validationSchema
}) {
  const {
    formattedCustomValidationErrors,
    formattedValidationSchema,
    handleChange,
    handleSubmit
  } = useEcosystemReviews({
    customValidationErrors,
    isEditing,
    editReason,
    offeringId,
    onChange,
    onFail,
    onSuccess,
    originalReview,
    overrideSubmitValidation,
    reviewFormatter,
    reviewId,
    reviewType,
    validationSchema
  });
  return /*#__PURE__*/_jsx(ReviewWizard, {
    customValidationErrors: formattedCustomValidationErrors,
    defaultReview: defaultReview,
    HeaderComponent: HeaderComponent,
    onChange: handleChange,
    onClose: onClose,
    onSubmit: handleSubmit,
    showLegalCheckbox: showLegalCheckbox,
    validationSchema: formattedValidationSchema,
    children: children
  });
}